// Single source of truth for which tool `type` strings have a
// captain-tasko-native React page. Used by:
//   - ToolsPanel: surfaces an "Open" button on matched rows
//   - AppShell (sidebar): when a nest has exactly one tool of a
//     matched type, the Tools cell deep-links directly to the
//     native page instead of bouncing through Settings → Tools.
//
// Add a row here AND register the route in apps/web/src/router.tsx
// when shipping a new native tool UI.

export const NATIVE_TOOL_TYPES: Record<string, string> = {
  'data-sources-registry': '/tools/data-sources-registry',
  'timeline': '/tools/timeline-lane',
};
